import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSupport } from "../../context/SupportContext";
import { useSelector } from "react-redux";
import { Box, Breadcrumbs, Skeleton, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import BlackWhiteSwitch from "../ManageUsers/BlackWhiteSwitch";
import { useEffect, useRef, useState } from "react";
import ApiService from "../../utils/fetch";
import { MessagePopup } from "../../Components/Common/messagePopup/MessagePopup";
import DataTable from "../../Components/Common/datatable/DataTable";
import InfoPopover from "../../Components/Common/poper/InfoPopover";
//check
function BPCountryConfiguration() {
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);

  const gridRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  let { combinationDetails, setCombinationDetails } = useSupport();

  const BottlerData = useSelector((state) => state.user.selectedBottler?.id);
  const BottlerName = useSelector(
    (state) => state.user.selectedBottler?.bottler,
  );

  useEffect(() => {
    if (BottlerName) {
      fetchUserDetails();
    }
  }, [BottlerName]);

  const fetchUserDetails = async () => {
    if (!BottlerName) return;
    try {
      setLoading(true);
      const response = await ApiService.get(
        `/v1/business-plan/getCountriesForBP?bottler=${encodeURIComponent(BottlerName)}`,
      );
      setFilteredData(response.data);
    } catch (error) {
      console.error("Error fetching BP Country config:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const resizeGrid = () => {
      if (gridRef.current && gridRef.current.api && filteredData.length > 0) {
        gridRef.current.api.sizeColumnsToFit();
      }
    };

    resizeGrid();
    window.addEventListener("resize", resizeGrid);
    return () => window.removeEventListener("resize", resizeGrid);
  }, [filteredData]);

  const columnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "country",
      headerName: "Customer Country",
      sortable: true,
      unSortIcon: true,
      width: 400,
      minWidth: 400,
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          { filter: "agTextColumnFilter" },
          { filter: "agSetColumnFilter" },
        ],
      },
    },
    {
      field: "isBottlerBusinessPlan",
      headerName: "Active",
      width: 320,
      minWidth: 320,
      sortable: true,
      sort: "desc",
      unSortIcon: true,

      headerComponent: (props) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Active</span>
          <input
            type="checkbox"
            style={{
              width: 20,
              height: 20,
              accentColor: "lightgrey",
              backgroundColor: "white",
            }}
            checked={filteredData.every((item) => item.isBottlerBusinessPlan)}
            onChange={async (event) => {
              const isChecked = event.target.checked;

              // Prepare bulk payload
              const payload = filteredData.map((item) => ({
                isBottlerBusinessPlan: isChecked,
                id: item.id,
                bottler: item.bottler,
                country: item.country,
              }));

              try {
                await ApiService.put(
                  "/v1/business-plan/updateCountriesForBP",
                  payload,
                );

                fetchUserDetails();

                MessagePopup({
                  icon: "success",
                  title: "Success",
                  message: `All Business Plan items turned ${
                    isChecked ? "ON" : "OFF"
                  } successfully.`,
                });
              } catch (error) {
                console.error("Bulk BP update error:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update all records. Please try again.",
                });
              }
            }}
          />
          <span>Bulk Turn ON/OFF</span>
        </div>
      ),

      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>OFF</span>
          <BlackWhiteSwitch
            checked={params.data.isBottlerBusinessPlan}
            onChange={async (event) => {
              const isChecked = event.target.checked;

              try {
                await ApiService.put("/v1/business-plan/updateCountriesForBP", [
                  {
                    isBottlerBusinessPlan: isChecked,
                    id: params.data.id,
                    bottler: params.data.bottler,
                    country: params.data.country,
                  },
                ]);

                // Immediate row update
                params.node.setDataValue("isBottlerBusinessPlan", isChecked);
                params.api.refreshClientSideRowModel("sort");
                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });

                // fetchUserDetails(); // Optional full refresh
              } catch (error) {
                console.error("Error updating BP Country:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>ON</span>
        </div>
      ),
    },
        {
      field: "isBusinessPlanCustomTemplate",
      headerName: "Template",
      width: 320,
      minWidth: 320,
      sortable: true,
      unSortIcon: true,

      headerComponent: (props) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Template</span>
          <input
            type="checkbox"
            style={{
              width: 20,
              height: 20,
              accentColor: "lightgrey",
              backgroundColor: "white",
            }}
            checked={filteredData.every(
              (item) => item.isBusinessPlanCustomTemplate,
            )}
            onChange={async (event) => {
              const isChecked = event.target.checked;

              const payload = filteredData.map((item) => ({
                customTemplateId: item.customTemplateId,
                bottler: item.bottler,
                country: item.country,
                isBusinessPlanCustomTemplate: isChecked,
              }));

              try {
                await ApiService.put(
                  "/bp-template-configuration/business-plan/update",
                  payload,
                );

                fetchUserDetails();

                MessagePopup({
                  icon: "success",
                  title: "Success",
                  message: `All items turned ${isChecked ? "Custom Template" : "Standard Template" } successfully.`,
                });
              } catch (error) {
                console.error("Bulk BP template update error:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update all records. Please try again.",
                });
              }
            }}
          />
          <span>Bulk Turn Custom/Standard</span>
        </div>
      ),

      cellRenderer: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 13, marginRight: 4 }}>Standard</span>
          <BlackWhiteSwitch
            checked={params.data.isBusinessPlanCustomTemplate}
            onChange={async (event) => {
              const isChecked = event.target.checked;

              try {
                await ApiService.put(
                  "/bp-template-configuration/business-plan/update",
                  [
                    {
                      customTemplateId: params.data.customTemplateId,
                      bottler: params.data.bottler,
                      country: params.data.country,
                      isBusinessPlanCustomTemplate: isChecked,
                    },
                  ],
                );

                params.node.setDataValue(
                  "isBusinessPlanCustomTemplate",
                  isChecked,
                );

                params.api.refreshCells({
                  rowNodes: [params.node],
                  force: true,
                });
              } catch (error) {
                console.error("Error updating BP template:", error);
                MessagePopup({
                  icon: "error",
                  title: "Error",
                  message: "Failed to update. Please try again.",
                });
              }
            }}
          />
          <span style={{ fontSize: 13, marginLeft: 4 }}>Custom</span>
        </div>
      ),
    },
  ];

  const onGrid = (params) => {
    const gridApi = params.api;
    if (gridApi) {
      gridApi.sizeColumnsToFit();
    }
  };

  const pagination = true;
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [5, 10, 20, 50, 100];

  const onSelectionChanged = (event) => {
    const selected = event.api.getSelectedRows();
    const combinationDetails = selected.map((row) => ({
      bottler: BottlerName ?? "",
      bottlerOwnerCode: null,
      profitCenterCountry: row.country ?? "",
    }));

    setCombinationDetails(combinationDetails);
  };

  return (
    <>
      <div>
        <Box>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 2, mt: 2 }}
          >
            <Link
              href="/bottler-onboarding"
              onClick={(e) => {
                e.preventDefault();
                navigate("/bottler-onboarding", {
                  state: { activeTab: "Bottler Business Plan" },
                });
              }}
              style={{ color: "black", textDecoration: "underline" }}
            >
              Bottler Configuration
            </Link>
            <Typography color="text.primary">
              Customer Country Configuration
            </Typography>
          </Breadcrumbs>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Bottler Business Plan Country Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
          </Box>

          <Typography variant="body1" sx={{ marginBottom: "10px" }}>
            Bottler: {BottlerName || ""}
          </Typography>

          {loading ? (
            <Skeleton
              variant="rectangular"
              height={"67vh"}
              animation="pulse"
              style={{ marginBottom: "16px", borderRadius: "8px" }}
            />
          ) : (
            <DataTable
              ref={gridRef}
              columns={columnDefinition}
              rows={filteredData || []}
              tableHeight={"67vh"}
              suppressMovableColumns={true}
              suppressHorizontalScroll={false}
              suppressPaginationPanel={false}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onGridReady={onGrid}
              rowSelection="multiple"
              onSelectionChanged={onSelectionChanged}
            />
          )}
        </Box>
      </div>
    </>
  );
}

export default BPCountryConfiguration;
